import { render } from "./ProductDescription.vue?vue&type=template&id=03ba11ea&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"

import "./ProductDescription.vue?vue&type=style&index=0&id=03ba11ea&scoped=true&lang=css"

import exportComponent from "/Users/macbook13dbs1/Documents/Vue/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ba11ea"]])

export default __exports__